export const flattenColors = colors => {
  if (!colors) return {}

  const flat = {}

  Object.values(colors).forEach(group => {
    if (!group?.types) return
    Object.values(group.types).forEach(type => {
      if (!type?.colors) return
      Object.values(type.colors).forEach(({ backendName, color }) => {
        if (backendName && color) flat[backendName] = color
      })
    })
  })

  return flat
}

export const flattenImages = images => {
  if (!images) return {}

  const flat = {}

  Object.entries(images).forEach(([key, image]) => {
    flat[`${key}_url`] = image?.preview || null
    if (image?.link?.key) {
      flat[image.link.key] = image.link.url || null
    }
  })

  return flat
}
